import makeUseCellCopyAction, {
  UseCellCopyActionProps,
} from "ds/components/Table/helpers/makeUseCellCopyAction";

import useBlueprintsAnalytics from "../hooks/useBlueprintsAnalytics";

const useCellCopyAction = (props: UseCellCopyActionProps) => {
  return makeUseCellCopyAction({ trackAnalytics: useBlueprintsAnalytics() })(props);
};

export default useCellCopyAction;
